import { forwardRef, ReactNode } from 'react'
import { LuCopy, LuCheck } from 'react-icons/lu'
import IconButton, { IconButtonProps } from '@mui/material/IconButton'
import useClipboard from '../hooks/useClipboard'

export type IconCopyButtonProps = Omit<IconButtonProps, 'color'> & {
  value?: string | number
  iconColor?: string
  iconCopyColor?: string
  icon?: ReactNode
  onClick?: () => void
  onCopy?: () => void
}

const IconCopyButton = forwardRef<HTMLButtonElement, IconCopyButtonProps>(
  ({ value, iconColor = 'text.disabled', iconCopyColor = 'success.main', icon, onClick, ...props }, ref) => {
    const { copy, copied } = useClipboard({ copiedTimeout: 1500 })

    const check = () => {
      onClick?.()
      if (value) copy(value)
    }

    return (
      <IconButton
        size="small"
        sx={{
          paddingX: 1,
          color: copied && iconCopyColor ? iconCopyColor : iconColor,
          ...props.sx,
        }}
        {...props}
        ref={ref}
        onClick={check}
      >
        {copied ? <LuCheck /> : (icon ?? <LuCopy />)}
      </IconButton>
    )
  }
)

export default IconCopyButton
